import { render, staticRenderFns } from "./FlightSelectClassType.vue?vue&type=template&id=1121abf7&scoped=true&"
import script from "./FlightSelectClassType.vue?vue&type=script&lang=js&"
export * from "./FlightSelectClassType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1121abf7",
  null
  
)

/* custom blocks */
import block0 from "./FlightSelectClassType.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VListItemContent,VSelect})
